import { EditOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import SignaturePad from "react-signature-pad-wrapper";
import { dataURLToFile } from "../../help-service/utils";

const SignatureComponent = ({ sign, onChange, errors }) => {
  const sigRef = useRef(null);
  const [signature, setSignature] = useState(null);
  const [edit, setEdit] = useState(false);
  
  useEffect(() => {
    if (sign) {
      setSignature(sign);
    }
  }, []);

  const saveSignature = async () => {
    if (sigRef.current) {
      if (sigRef.current.isEmpty()) {
        return;
      }
      const dataURL = sigRef.current.toDataURL("image/png");
      setSignature(dataURL);
      setEdit(false);
      // const blob = await fetch(dataURL).then((res) => res.blob());
      // const file = new File([blob], "signature.png", { type: "image/png" });
      const file = dataURLToFile(dataURL, "signature.png");
      onChange(file);
    }
  };

  const clearSignature = () => {
    if (sigRef.current) {
      sigRef.current.clear();
      setSignature(null);
      onChange(null);
      setEdit(true);
    }
  };

  return (
    <>
      {signature && !edit ? (
        <div className="mt-3 position-relative border border-1 border-gray rounded">
          <span className="position-absolute top-3 end-0 p-2 cursor-pointer">
            <span
              onClick={() => {
                setEdit(true);
                setTimeout(() => {
                  if (sigRef.current && signature) {
                    sigRef.current.fromDataURL(signature);
                  }
                }, 0);
              }}
            >
              <EditOutlined className="me-2" />
              Edit
            </span>
          </span>
          <img
            src={signature}
            alt="signature preview"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
      ) : (
        <>
          <SignaturePad
            ref={sigRef}
            options={{
              minWidth: 1,
              maxWidth: 2,
              penColor: "black",
              backgroundColor: "white",
            }}
            canvasProps={{
              width: 500,
              height: 90,
              style: {
                border: `${
                  errors.itl_declarationsignature
                    ? "1px solid #eb5e5e"
                    : "1px solid #afafafff"
                }`,
                borderRadius: "4px",
              },
            }}
          />
          <div className="input-error" style={{ bottom: "-17px" }}>
            {errors.itl_declarationsignature}
          </div>
          <div className="mt-2 gap-2 d-flex justify-content-end">
            <button
              className="btn btn-sm btn-primary btn-blue border-none"
              onClick={saveSignature}
            >
              Save
            </button>
            <button
              className="btn btn-sm btn-outline-dark"
              onClick={clearSignature}
            >
              Clear
            </button>
            {signature && (
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => setEdit(false)}
              >
                Cancel
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default SignatureComponent;
